var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMintCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0002,
    cy: 17.9995,
    r: 12,
    fill: "#0799B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2502 17.9995L17.0735 20.8227C17.1711 20.9204 17.3294 20.9204 17.427 20.8227L23.2502 14.9995",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintCheckmarkIcon);
export default __webpack_public_path__ + "static/media/mintCheckmarkIcon.bc2fc221413e8ed5f73004b64837ef3a.svg";
export { ForwardRef as ReactComponent };